// Numeros de WhatsApp da vitrine publica, lidos do backend (fonte unica em
// `contato-catalogo.ts`). Antes cada pagina publica tinha o numero CRAVADO no
// href E escrito no texto, em literais separados — quando o atendimento trocou
// de numero (DA-482), a vitrine inteira continuou apontando pro numero morto.
//
// Cache no modulo: rodape + pagina renderizam juntos e o /config e o mesmo pra
// todo mundo. Sem isso seriam varios fetch identicos por navegacao.
import { useEffect, useState } from 'react';

export type ContatoWhatsapp = {
  numero: string; // 556499561692
  display: string; // (64) 99956-1692
  link: string; // https://wa.me/556499561692
};

let cache: ContatoWhatsapp[] | null = null;
let voando: Promise<ContatoWhatsapp[]> | null = null;

function buscar(): Promise<ContatoWhatsapp[]> {
  if (cache) return Promise.resolve(cache);
  if (voando) return voando;
  voando = fetch('/api/public/catalogo/config')
    .then((r) => r.json())
    .then((d) => {
      const lista: ContatoWhatsapp[] = Array.isArray(d?.whatsapp_numeros) ? d.whatsapp_numeros : [];
      cache = lista;
      return lista;
    })
    .catch(() => [])
    .finally(() => {
      voando = null;
    });
  return voando;
}

// Devolve [] enquanto carrega ou se o backend falhar. Quem exibe deve tratar a
// lista vazia escondendo o contato — melhor sumir o telefone por um instante
// que mostrar um numero errado, que foi o defeito que originou tudo isto.
export function useContatoCatalogo(): ContatoWhatsapp[] {
  const [contatos, setContatos] = useState<ContatoWhatsapp[]>(cache ?? []);

  useEffect(() => {
    let vivo = true;
    buscar().then((lista) => {
      if (vivo) setContatos(lista);
    });
    return () => {
      vivo = false;
    };
  }, []);

  return contatos;
}
